module.exports = __webpack_public_path__ + "static/img/6.dde8f3e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/2/sp/6.png
// module id = HS9E
// module chunks = 0